<section
  *ngIf="!multiple"
  class="{{ cssClass(alertType) }}"
  [ngClass]="{'margin-fixed': marginBottom}"
  id="alert-section{{ inId }}"
>
  <h3 *ngIf="title" id="alert-heading{{ inId }}">
    {{ title }}
    <small *ngIf="alertNumber" class="mrgn-lft-sm">({{ 'concepts.alert.code' | translate }}: {{ alertNumber }})</small
    >
  </h3>
  <div id="alert-content{{ inId }}" [innerHtml]="content"></div>
  <div>
    <ng-content select="[alert-html-content]"></ng-content>
  </div>
  <div *ngIf="contentDetailLink">
    <a [carmRouterLink]="[contentDetailLink]">{{
      'concepts.alert.alertDetailHere' | translate
    }}</a>
  </div>
</section>
<section
  *ngIf="multiple"
  class="{{ cssClass(alertType) }}"
  id="alert-section{{ inId }}"
>
  <h3 *ngIf="title" id="alert-heading{{ inId }}">{{ title }}</h3>
  <ul>
    <li *ngFor="let form of content">
      {{ form.message }}
    </li>
  </ul>
</section>
